// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"baadbcc85a91b0d3b7d4","883":"dc14c97ae9f806ec30cb"}[chunkId] + ".js";
};